import React from 'react'
import {
  Popup
} from 'semantic-ui-react'
import {outcomeCounts, topicCounts} from './itemInfo.js'
import {countItems, addItemCounts, isItemId, isOutcomeId, isTopicId, colorValues} from './utils.js'

const Bar = (props)=>{
  const {color, width, thin, ...passOnProps} = props;
  //console.log("Bar::render()", color, width);
  return (
    <div {...passOnProps} style={{
      background: colorValues[color],
      width: width,
      height: thin?'6px':'6px', //change?
      display: 'inline-block'
    }}/>
  );
}

const BarWithToolTip = (props) => {
  const {color, width, thin, toolTipContent} = props;
  //console.log("BarWithToolTip::render()", toolTipContent);
  return (
    <Popup
      trigger={
        <Bar color={color} width={width} thin={thin}/>
      }
      content={toolTipContent}
    />
  );
}

// One bar for each choice of each enum
const OverallItemBars = ({comparisonSelections, fqidPrefix, itemKind, percent}) => {
  //console.log("OverallItemBars::render()", comparisonSelections, fqidPrefix, itemKind, percent);
  if(comparisonSelections.length===0) {
    return null;
  }
  const counts = comparisonSelections.map(selection=>countItems(fqidPrefix, itemKind, selection.items, selection.type)).reduce((count1, count2)=>{
    return addItemCounts(count1, count2);
  });
  const type = comparisonSelections[0].type; // need to pick one
  let total = 0;
  if (itemKind==='outcomes'||itemKind==='both'||itemKind===undefined) {
    total += isItemId(fqidPrefix)?(isOutcomeId(fqidPrefix)?1:0):outcomeCounts[fqidPrefix];
  }
  if (itemKind==='topics'||itemKind==='both'||itemKind===undefined) {
    total += isItemId(fqidPrefix)?(isTopicId(fqidPrefix)?1:0):topicCounts[fqidPrefix];
  }
  total *= comparisonSelections.length;
  let what = itemKind==='outcomes'?'Outcomes':(itemKind==='topics'?'Topics':'Items');
  return (
    type.map((e,ei)=>{
      const nothingCount = total-e.choices.map((c,ci)=>counts[e.id][c.id]).reduce((x,y)=>x+y, 0);
      return (
        <span key={ei} style={{marginRight: '8px'}}>
          {
            [...e.choices].reverse().map((c,ci)=>
              <BarWithToolTip
                key={ci}
                color={c.color}
                width={percent?counts[e.id][c.id]/total*100:counts[e.id][c.id]}
                toolTipContent={
                  <div>
                    <strong>{e.name}:</strong> {c.name}
                    <p style={{fontSize: '80%'}}>
                      <span style={{color: 'grey'}}>{c.description}</span>
                    </p>
                    <p>{counts[e.id][c.id]+' '+what+' within '+fqidPrefix}</p>
                  </div>
                }
              />
            )
          }
          <BarWithToolTip
            thin
            color='default'
            width={percent?(nothingCount/total*100):nothingCount}
            toolTipContent={
              <div>
                <strong>{e.name}:</strong> Nothing
                <p style={{fontSize: '80%'}}>
                  <span style={{color: 'grey'}}>None of the choices selected</span>
                </p>
                <p>{nothingCount+' '+what+' within '+fqidPrefix}</p>
              </div>
            }
          />
        </span>
      );
    })
  );
}

export default OverallItemBars